import { faker } from '@faker-js/faker';
import { IAddressEntity } from '../entitites/common/address.entity';

export const CUSTOMER_TYPE = ['organization', 'consumer'] as const;
export const CUSTOMER_STATUS = ['active', 'inactive', 'prospect'] as const;
export const BILLING_UNIT = ['monthly', 'yearly', 'mixed'] as const;
export const INSURANCE_STATUS = [
  'active',
  'cancelled',
  'needs_review',
  'active_pending',
  'cancelled_pending',
] as const;
export const CLAIM_STATUS = ['in_progress', 'in_review', 'cancelled'] as const;
export const ACTIVITY_LINKED_ITEM_TYPE = [
  'claim',
  'task',
  'insurance',
  'client',
  'quotation',
  'note',
] as const;
export const ACTIVITY_TYPE = ['email', 'mutation'] as const;
export const ACTIVITY_STATUS = [
  'claim',
  'task',
  'insurance',
  'client',
  'quotation',
  'note',
] as const;
export const TASK_STATUS = ['not_started', 'in_progress', 'closed'] as const;
export const TASK_PRIORITY = ['low', 'medium', 'high', 'critical'] as const;
export const TASK_LINKED_ITEM_TYPE = [
  'claim',
  'insurance',
  'quotation',
  'task',
  'customer',
] as const;

export function getAddress(): IAddressEntity {
  return {
    street: faker.location.street(),
    city: faker.location.city(),
    house_number_appendix: undefined,
    country: faker.location.country(),
    postal_code: faker.location.zipCode(),
    house_number: faker.number.int({ min: 1, max: 125 }),
  };
}

export function getPerson() {
  const first_name = faker.person.firstName();
  const last_name = faker.person.lastName();
  const initials = first_name[0] + last_name[0];

  return {
    guid: faker.string.uuid(),
    initials,
    first_name,
    last_name,
    email: faker.internet.email(),
    phone: faker.phone.number(),
    phone_mobile: faker.phone.number(),
    date_of_birth: faker.date.past().toString(),
  };
}

export function getBroker() {
  const { date_of_birth, ...rest } = getPerson();
  return {
    ...rest,
    avatar: rest.initials,
    job_title: faker.helpers.arrayElement(['broker', 'admin']),
  };
}
